import React from 'react'
import {Checkbox as MuiCheckbox, FormHelperText, Table, TableCell, TableHead, TableBody, TableRow, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import Checkbox from 'components/Checkbox';
import getObjectValue from 'libs/getObjectValue';
import clsx from "clsx";


const style = theme => ({
    root: {
        marginBottom: theme.spacing(2)
    },
    textBold: {
        fontWeight: theme.typography.fontWeightBold,
    },
    smallColumn: theme.components.table.lpColumn,
    orderColumn: theme.components.table.ipColumn,
    checkboxColumn: {
        width: theme.spacing()
    },
    cells: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    checkbox: {
        padding: 0,
    },
    cursor: {
        cursor: "pointer"
    },
    table: {
        tableLayout: 'fixed',

        '& td, th': {
            overflow: 'hidden',
        }
    },
    contractorsTable: {
        '& tr:last-child td': {
            borderBottom: 'none'
        }
    },
    rowHidden: {
        visibility: 'collapse'
    },
    divHidden: {
        maxHeight: '0px !important'
    },
    divOpen: {
        maxHeight: '2000px'
    },
    elemTransition: {
        transition: 'all 0.8s'
    }
})

function CreateAdditionalRoundTable(
    {
        classes,
        className,
        formikProps,
        id,
        elementList = [],
        showContractors,
        label,
        editable = true,
        required = true,
        disabled
    }) {
    const elements = getObjectValue(id, formikProps.values, []);
    const errorValue = getObjectValue(id, formikProps.errors, '');
    const touched = getObjectValue(id, formikProps.touched, false);
    const isAllChecked = elementList.length > 0 && !elementList.find(x => elements[x.identity].checked !== true)

    const handleHeadCheckboxChange = (e, value) => {
        elementList.forEach(x => formikProps.setFieldValue(id + '.' + x.identity + '.checked', value));
    }

    const handleContractorsHeadCheckboxChange = (e, value, elemId) => {
        const position = elementList.find(x => x.identity === elemId);
        position.contractors.forEach(c => formikProps.setFieldValue(id + '.' + position.identity + '.contractors.' + c.identity, value));
    }

    const isError = editable && !!errorValue && Boolean(touched);
    const helperText = errorValue || ' ';
    return (
        <GridBlock
            className={clsx(classes.root, className)}
            column
        >
            <Typography
                variant='body1'
                className={classes.textBold}
            >
                {label ? label : Tr('assign_to_part')}{required ? '*' : ''}
            </Typography>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        <TableCell className={clsx(classes.checkboxColumn, classes.cells)}><MuiCheckbox
                            color='primary'
                            className={classes.checkbox}
                            onChange={handleHeadCheckboxChange}
                            checked={isAllChecked}
                            disabled={disabled}
                        /></TableCell>
                        <TableCell className={clsx(classes.orderColumn, classes.cells)}>{Tr('part_number')}</TableCell>
                        <TableCell className={classes.cells}>{Tr('name')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {elementList.map((x, i) => {
                            const positionChecked = elements[x.identity].checked;
                            const allContractorsChecked = !!elements[x.identity].contractors && !Object.keys(elements[x.identity].contractors).find(c => elements[x.identity].contractors[c] !== true);
                            return (
                                <React.Fragment key={`p.${x.identity}`}>
                                    <TableRow>
                                        <TableCell className={clsx(classes.checkboxColumn, classes.cells)}><Checkbox
                                            id={`${id}.${x.identity}.checked`}
                                            formikProps={formikProps}
                                            checkboxClassName={classes.checkbox}
                                            htmlId={`${id}.${x.identity}.checked`}
                                            disabled={disabled}
                                        /></TableCell>
                                        <TableCell className={clsx(classes.orderColumn, classes.cells)}><label className={classes.cursor}
                                                                                                               htmlFor={`${id}.${x.identity}.checked`}>{x.order}</label></TableCell>
                                        <TableCell className={classes.cells}><label className={classes.cursor}
                                                                                    htmlFor={`${id}.${x.identity}.checked`}>{x.name}</label></TableCell>
                                    </TableRow>

                                    {showContractors &&
                                    <TableRow className={clsx(classes.elemTransition, {[classes.rowHidden]: !positionChecked})}>
                                        <TableCell className={clsx(classes.checkboxColumn, classes.cells, classes.elemTransition)}></TableCell>
                                        <TableCell className={clsx(classes.cells, classes.elemTransition)} colSpan={2}>
                                            <div className={clsx(classes.elemTransition, {[classes.divHidden]: !positionChecked}, classes.divOpen)}>
                                            <Table className={clsx(classes.table, classes.contractorsTable)}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className={clsx(classes.checkboxColumn, classes.cells)}><MuiCheckbox
                                                            color='primary'
                                                            className={classes.checkbox}
                                                            onChange={(e, value) => handleContractorsHeadCheckboxChange(e, value, x.identity)}
                                                            checked={allContractorsChecked}
                                                            disabled={disabled}
                                                        /></TableCell>
                                                        <TableCell className={clsx(classes.orderColumn, classes.cells)}>{Tr('column_lp')}</TableCell>
                                                        <TableCell className={classes.cells}>{Tr('contractor')}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {x.contractors.map((c, i) => {
                                                        return (
                                                            <TableRow key={`cd.${x.identity}.${c.identity}`}>
                                                                <TableCell className={clsx(classes.checkboxColumn, classes.cells)}><Checkbox
                                                                    id={`${id}.${x.identity}.contractors.${c.identity}`}
                                                                    formikProps={formikProps}
                                                                    checkboxClassName={classes.checkbox}
                                                                    htmlId={`${id}.${x.identity}.contractors.${c.identity}`}
                                                                    disabled={disabled}
                                                                /></TableCell>
                                                                <TableCell className={clsx(classes.orderColumn, classes.cells)}><label
                                                                    className={classes.cursor}
                                                                    htmlFor={`${id}.${x.identity}.contractors.${c.identity}`}>{i + 1}</label></TableCell>
                                                                <TableCell className={classes.cells}><label className={classes.cursor}
                                                                                                            htmlFor={`${id}.${x.identity}.contractors.${c.identity}`}>{c.name}</label></TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                                </TableBody>
                                            </Table>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                    }
                                </React.Fragment>
                            )
                        }
                    )}
                </TableBody>
            </Table>
            {isError && <FormHelperText error>{helperText}</FormHelperText>}
        </GridBlock>
    )
}

CreateAdditionalRoundTable.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(CreateAdditionalRoundTable);
